export const USER_ROLES = {
  CLEANER: 'Cleaner',
  SUPPORT_ADMIN: 'Support Admin',
  SYSTEM_ADMIN: 'System Admin',
  PORTFOLIO_CUSTOMER: 'PortfolioCustomer',
  PORTFOLIO_USER: 'PortfolioUser',
} as const;

export type UserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];
